import React from "react"

import { AuthProvider } from "@contexts/auth/auth"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

import { Layout } from "@layout"

const queryClient = new QueryClient()

const wrapPageElement = ({ element, props }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Layout {...props}>{element}</Layout>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default wrapPageElement
